var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "content" },
    [
      _c("Username", { attrs: { user: _vm.message.from } }),
      _vm._v("\n\thas changed\n\t"),
      _vm.message.new_ident
        ? _c("span", [
            _vm._v("username to "),
            _c("b", [_vm._v(_vm._s(_vm.message.new_ident))]),
          ])
        : _vm._e(),
      _vm.message.new_host
        ? _c("span", [
            _vm._v("hostname to\n\t\t"),
            _c(
              "i",
              { staticClass: "hostmask" },
              [
                _c("ParsedMessage", {
                  attrs: { network: _vm.network, text: _vm.message.new_host },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }